import { render, staticRenderFns } from "./ver_factura_ispi.vue?vue&type=template&id=307c5a88"
import script from "./ver_factura_ispi.vue?vue&type=script&lang=js"
export * from "./ver_factura_ispi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports